import { __exports as m } from "../../../../_virtual/inflate.es2.js";
import { __require as je } from "../utils/common.es.js";
import { __require as $e } from "./adler32.es.js";
import { __require as Je } from "./crc32.es.js";
import { __require as Qe } from "./inffast.es.js";
import { __require as Ve } from "./inftrees.es.js";
var Ce;
function na() {
  if (Ce) return m;
  Ce = 1;
  var _ = je(), G = $e(), T = Je(), Ne = Qe(), N = Ve(), Oe = 0, U = 1, W = 2, j = 4, ze = 5, O = 6, C = 0, Le = 1, Ae = 2, E = -2, $ = -3, J = -4, Me = -5, Q = 8, V = 1, y = 2, ee = 3, ae = 4, ie = 5, fe = 6, te = 7, ne = 8, re = 9, le = 10, z = 11, I = 12, F = 13, oe = 14, K = 15, de = 16, he = 17, se = 18, ce = 19, L = 20, A = 21, ve = 22, be = 23, ke = 24, xe = 25, ue = 26, X = 27, we = 28, _e = 29, h = 30, ge = 31, Ze = 32, qe = 852, He = 592, Ge = 15, Fe = Ge;
  function Ee(a) {
    return (a >>> 24 & 255) + (a >>> 8 & 65280) + ((a & 65280) << 8) + ((a & 255) << 24);
  }
  function Ke() {
    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new _.Buf16(320), this.work = new _.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
  }
  function pe(a) {
    var n;
    return !a || !a.state ? E : (n = a.state, a.total_in = a.total_out = n.total = 0, a.msg = "", n.wrap && (a.adler = n.wrap & 1), n.mode = V, n.last = 0, n.havedict = 0, n.dmax = 32768, n.head = null, n.hold = 0, n.bits = 0, n.lencode = n.lendyn = new _.Buf32(qe), n.distcode = n.distdyn = new _.Buf32(He), n.sane = 1, n.back = -1, C);
  }
  function Se(a) {
    var n;
    return !a || !a.state ? E : (n = a.state, n.wsize = 0, n.whave = 0, n.wnext = 0, pe(a));
  }
  function me(a, n) {
    var e, l;
    return !a || !a.state || (l = a.state, n < 0 ? (e = 0, n = -n) : (e = (n >> 4) + 1, n < 48 && (n &= 15)), n && (n < 8 || n > 15)) ? E : (l.window !== null && l.wbits !== n && (l.window = null), l.wrap = e, l.wbits = n, Se(a));
  }
  function Te(a, n) {
    var e, l;
    return a ? (l = new Ke(), a.state = l, l.window = null, e = me(a, n), e !== C && (a.state = null), e) : E;
  }
  function Xe(a) {
    return Te(a, Fe);
  }
  var Re = !0, Y, B;
  function Ye(a) {
    if (Re) {
      var n;
      for (Y = new _.Buf32(512), B = new _.Buf32(32), n = 0; n < 144; )
        a.lens[n++] = 8;
      for (; n < 256; )
        a.lens[n++] = 9;
      for (; n < 280; )
        a.lens[n++] = 7;
      for (; n < 288; )
        a.lens[n++] = 8;
      for (N(U, a.lens, 0, 288, Y, 0, a.work, { bits: 9 }), n = 0; n < 32; )
        a.lens[n++] = 5;
      N(W, a.lens, 0, 32, B, 0, a.work, { bits: 5 }), Re = !1;
    }
    a.lencode = Y, a.lenbits = 9, a.distcode = B, a.distbits = 5;
  }
  function Ie(a, n, e, l) {
    var s, t = a.state;
    return t.window === null && (t.wsize = 1 << t.wbits, t.wnext = 0, t.whave = 0, t.window = new _.Buf8(t.wsize)), l >= t.wsize ? (_.arraySet(t.window, n, e - t.wsize, t.wsize, 0), t.wnext = 0, t.whave = t.wsize) : (s = t.wsize - t.wnext, s > l && (s = l), _.arraySet(t.window, n, e - l, s, t.wnext), l -= s, l ? (_.arraySet(t.window, n, e - l, l, 0), t.wnext = l, t.whave = t.wsize) : (t.wnext += s, t.wnext === t.wsize && (t.wnext = 0), t.whave < t.wsize && (t.whave += s))), 0;
  }
  function Be(a, n) {
    var e, l, s, t, p, r, k, f, i, M, c, o, Z, P, v = 0, d, u, g, w, q, H, b, S, x = new _.Buf8(4), D, R, De = (
      /* permutation of code lengths */
      [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]
    );
    if (!a || !a.state || !a.output || !a.input && a.avail_in !== 0)
      return E;
    e = a.state, e.mode === I && (e.mode = F), p = a.next_out, s = a.output, k = a.avail_out, t = a.next_in, l = a.input, r = a.avail_in, f = e.hold, i = e.bits, M = r, c = k, S = C;
    e:
      for (; ; )
        switch (e.mode) {
          case V:
            if (e.wrap === 0) {
              e.mode = F;
              break;
            }
            for (; i < 16; ) {
              if (r === 0)
                break e;
              r--, f += l[t++] << i, i += 8;
            }
            if (e.wrap & 2 && f === 35615) {
              e.check = 0, x[0] = f & 255, x[1] = f >>> 8 & 255, e.check = T(e.check, x, 2, 0), f = 0, i = 0, e.mode = y;
              break;
            }
            if (e.flags = 0, e.head && (e.head.done = !1), !(e.wrap & 1) || /* check if zlib header allowed */
            (((f & 255) << 8) + (f >> 8)) % 31) {
              a.msg = "incorrect header check", e.mode = h;
              break;
            }
            if ((f & 15) !== Q) {
              a.msg = "unknown compression method", e.mode = h;
              break;
            }
            if (f >>>= 4, i -= 4, b = (f & 15) + 8, e.wbits === 0)
              e.wbits = b;
            else if (b > e.wbits) {
              a.msg = "invalid window size", e.mode = h;
              break;
            }
            e.dmax = 1 << b, a.adler = e.check = 1, e.mode = f & 512 ? le : I, f = 0, i = 0;
            break;
          case y:
            for (; i < 16; ) {
              if (r === 0)
                break e;
              r--, f += l[t++] << i, i += 8;
            }
            if (e.flags = f, (e.flags & 255) !== Q) {
              a.msg = "unknown compression method", e.mode = h;
              break;
            }
            if (e.flags & 57344) {
              a.msg = "unknown header flags set", e.mode = h;
              break;
            }
            e.head && (e.head.text = f >> 8 & 1), e.flags & 512 && (x[0] = f & 255, x[1] = f >>> 8 & 255, e.check = T(e.check, x, 2, 0)), f = 0, i = 0, e.mode = ee;
          case ee:
            for (; i < 32; ) {
              if (r === 0)
                break e;
              r--, f += l[t++] << i, i += 8;
            }
            e.head && (e.head.time = f), e.flags & 512 && (x[0] = f & 255, x[1] = f >>> 8 & 255, x[2] = f >>> 16 & 255, x[3] = f >>> 24 & 255, e.check = T(e.check, x, 4, 0)), f = 0, i = 0, e.mode = ae;
          case ae:
            for (; i < 16; ) {
              if (r === 0)
                break e;
              r--, f += l[t++] << i, i += 8;
            }
            e.head && (e.head.xflags = f & 255, e.head.os = f >> 8), e.flags & 512 && (x[0] = f & 255, x[1] = f >>> 8 & 255, e.check = T(e.check, x, 2, 0)), f = 0, i = 0, e.mode = ie;
          case ie:
            if (e.flags & 1024) {
              for (; i < 16; ) {
                if (r === 0)
                  break e;
                r--, f += l[t++] << i, i += 8;
              }
              e.length = f, e.head && (e.head.extra_len = f), e.flags & 512 && (x[0] = f & 255, x[1] = f >>> 8 & 255, e.check = T(e.check, x, 2, 0)), f = 0, i = 0;
            } else e.head && (e.head.extra = null);
            e.mode = fe;
          case fe:
            if (e.flags & 1024 && (o = e.length, o > r && (o = r), o && (e.head && (b = e.head.extra_len - e.length, e.head.extra || (e.head.extra = new Array(e.head.extra_len)), _.arraySet(
              e.head.extra,
              l,
              t,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              o,
              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
              b
            )), e.flags & 512 && (e.check = T(e.check, l, o, t)), r -= o, t += o, e.length -= o), e.length))
              break e;
            e.length = 0, e.mode = te;
          case te:
            if (e.flags & 2048) {
              if (r === 0)
                break e;
              o = 0;
              do
                b = l[t + o++], e.head && b && e.length < 65536 && (e.head.name += String.fromCharCode(b));
              while (b && o < r);
              if (e.flags & 512 && (e.check = T(e.check, l, o, t)), r -= o, t += o, b)
                break e;
            } else e.head && (e.head.name = null);
            e.length = 0, e.mode = ne;
          case ne:
            if (e.flags & 4096) {
              if (r === 0)
                break e;
              o = 0;
              do
                b = l[t + o++], e.head && b && e.length < 65536 && (e.head.comment += String.fromCharCode(b));
              while (b && o < r);
              if (e.flags & 512 && (e.check = T(e.check, l, o, t)), r -= o, t += o, b)
                break e;
            } else e.head && (e.head.comment = null);
            e.mode = re;
          case re:
            if (e.flags & 512) {
              for (; i < 16; ) {
                if (r === 0)
                  break e;
                r--, f += l[t++] << i, i += 8;
              }
              if (f !== (e.check & 65535)) {
                a.msg = "header crc mismatch", e.mode = h;
                break;
              }
              f = 0, i = 0;
            }
            e.head && (e.head.hcrc = e.flags >> 9 & 1, e.head.done = !0), a.adler = e.check = 0, e.mode = I;
            break;
          case le:
            for (; i < 32; ) {
              if (r === 0)
                break e;
              r--, f += l[t++] << i, i += 8;
            }
            a.adler = e.check = Ee(f), f = 0, i = 0, e.mode = z;
          case z:
            if (e.havedict === 0)
              return a.next_out = p, a.avail_out = k, a.next_in = t, a.avail_in = r, e.hold = f, e.bits = i, Ae;
            a.adler = e.check = 1, e.mode = I;
          case I:
            if (n === ze || n === O)
              break e;
          case F:
            if (e.last) {
              f >>>= i & 7, i -= i & 7, e.mode = X;
              break;
            }
            for (; i < 3; ) {
              if (r === 0)
                break e;
              r--, f += l[t++] << i, i += 8;
            }
            switch (e.last = f & 1, f >>>= 1, i -= 1, f & 3) {
              case 0:
                e.mode = oe;
                break;
              case 1:
                if (Ye(e), e.mode = L, n === O) {
                  f >>>= 2, i -= 2;
                  break e;
                }
                break;
              case 2:
                e.mode = he;
                break;
              case 3:
                a.msg = "invalid block type", e.mode = h;
            }
            f >>>= 2, i -= 2;
            break;
          case oe:
            for (f >>>= i & 7, i -= i & 7; i < 32; ) {
              if (r === 0)
                break e;
              r--, f += l[t++] << i, i += 8;
            }
            if ((f & 65535) !== (f >>> 16 ^ 65535)) {
              a.msg = "invalid stored block lengths", e.mode = h;
              break;
            }
            if (e.length = f & 65535, f = 0, i = 0, e.mode = K, n === O)
              break e;
          case K:
            e.mode = de;
          case de:
            if (o = e.length, o) {
              if (o > r && (o = r), o > k && (o = k), o === 0)
                break e;
              _.arraySet(s, l, t, o, p), r -= o, t += o, k -= o, p += o, e.length -= o;
              break;
            }
            e.mode = I;
            break;
          case he:
            for (; i < 14; ) {
              if (r === 0)
                break e;
              r--, f += l[t++] << i, i += 8;
            }
            if (e.nlen = (f & 31) + 257, f >>>= 5, i -= 5, e.ndist = (f & 31) + 1, f >>>= 5, i -= 5, e.ncode = (f & 15) + 4, f >>>= 4, i -= 4, e.nlen > 286 || e.ndist > 30) {
              a.msg = "too many length or distance symbols", e.mode = h;
              break;
            }
            e.have = 0, e.mode = se;
          case se:
            for (; e.have < e.ncode; ) {
              for (; i < 3; ) {
                if (r === 0)
                  break e;
                r--, f += l[t++] << i, i += 8;
              }
              e.lens[De[e.have++]] = f & 7, f >>>= 3, i -= 3;
            }
            for (; e.have < 19; )
              e.lens[De[e.have++]] = 0;
            if (e.lencode = e.lendyn, e.lenbits = 7, D = { bits: e.lenbits }, S = N(Oe, e.lens, 0, 19, e.lencode, 0, e.work, D), e.lenbits = D.bits, S) {
              a.msg = "invalid code lengths set", e.mode = h;
              break;
            }
            e.have = 0, e.mode = ce;
          case ce:
            for (; e.have < e.nlen + e.ndist; ) {
              for (; v = e.lencode[f & (1 << e.lenbits) - 1], d = v >>> 24, u = v >>> 16 & 255, g = v & 65535, !(d <= i); ) {
                if (r === 0)
                  break e;
                r--, f += l[t++] << i, i += 8;
              }
              if (g < 16)
                f >>>= d, i -= d, e.lens[e.have++] = g;
              else {
                if (g === 16) {
                  for (R = d + 2; i < R; ) {
                    if (r === 0)
                      break e;
                    r--, f += l[t++] << i, i += 8;
                  }
                  if (f >>>= d, i -= d, e.have === 0) {
                    a.msg = "invalid bit length repeat", e.mode = h;
                    break;
                  }
                  b = e.lens[e.have - 1], o = 3 + (f & 3), f >>>= 2, i -= 2;
                } else if (g === 17) {
                  for (R = d + 3; i < R; ) {
                    if (r === 0)
                      break e;
                    r--, f += l[t++] << i, i += 8;
                  }
                  f >>>= d, i -= d, b = 0, o = 3 + (f & 7), f >>>= 3, i -= 3;
                } else {
                  for (R = d + 7; i < R; ) {
                    if (r === 0)
                      break e;
                    r--, f += l[t++] << i, i += 8;
                  }
                  f >>>= d, i -= d, b = 0, o = 11 + (f & 127), f >>>= 7, i -= 7;
                }
                if (e.have + o > e.nlen + e.ndist) {
                  a.msg = "invalid bit length repeat", e.mode = h;
                  break;
                }
                for (; o--; )
                  e.lens[e.have++] = b;
              }
            }
            if (e.mode === h)
              break;
            if (e.lens[256] === 0) {
              a.msg = "invalid code -- missing end-of-block", e.mode = h;
              break;
            }
            if (e.lenbits = 9, D = { bits: e.lenbits }, S = N(U, e.lens, 0, e.nlen, e.lencode, 0, e.work, D), e.lenbits = D.bits, S) {
              a.msg = "invalid literal/lengths set", e.mode = h;
              break;
            }
            if (e.distbits = 6, e.distcode = e.distdyn, D = { bits: e.distbits }, S = N(W, e.lens, e.nlen, e.ndist, e.distcode, 0, e.work, D), e.distbits = D.bits, S) {
              a.msg = "invalid distances set", e.mode = h;
              break;
            }
            if (e.mode = L, n === O)
              break e;
          case L:
            e.mode = A;
          case A:
            if (r >= 6 && k >= 258) {
              a.next_out = p, a.avail_out = k, a.next_in = t, a.avail_in = r, e.hold = f, e.bits = i, Ne(a, c), p = a.next_out, s = a.output, k = a.avail_out, t = a.next_in, l = a.input, r = a.avail_in, f = e.hold, i = e.bits, e.mode === I && (e.back = -1);
              break;
            }
            for (e.back = 0; v = e.lencode[f & (1 << e.lenbits) - 1], d = v >>> 24, u = v >>> 16 & 255, g = v & 65535, !(d <= i); ) {
              if (r === 0)
                break e;
              r--, f += l[t++] << i, i += 8;
            }
            if (u && !(u & 240)) {
              for (w = d, q = u, H = g; v = e.lencode[H + ((f & (1 << w + q) - 1) >> w)], d = v >>> 24, u = v >>> 16 & 255, g = v & 65535, !(w + d <= i); ) {
                if (r === 0)
                  break e;
                r--, f += l[t++] << i, i += 8;
              }
              f >>>= w, i -= w, e.back += w;
            }
            if (f >>>= d, i -= d, e.back += d, e.length = g, u === 0) {
              e.mode = ue;
              break;
            }
            if (u & 32) {
              e.back = -1, e.mode = I;
              break;
            }
            if (u & 64) {
              a.msg = "invalid literal/length code", e.mode = h;
              break;
            }
            e.extra = u & 15, e.mode = ve;
          case ve:
            if (e.extra) {
              for (R = e.extra; i < R; ) {
                if (r === 0)
                  break e;
                r--, f += l[t++] << i, i += 8;
              }
              e.length += f & (1 << e.extra) - 1, f >>>= e.extra, i -= e.extra, e.back += e.extra;
            }
            e.was = e.length, e.mode = be;
          case be:
            for (; v = e.distcode[f & (1 << e.distbits) - 1], d = v >>> 24, u = v >>> 16 & 255, g = v & 65535, !(d <= i); ) {
              if (r === 0)
                break e;
              r--, f += l[t++] << i, i += 8;
            }
            if (!(u & 240)) {
              for (w = d, q = u, H = g; v = e.distcode[H + ((f & (1 << w + q) - 1) >> w)], d = v >>> 24, u = v >>> 16 & 255, g = v & 65535, !(w + d <= i); ) {
                if (r === 0)
                  break e;
                r--, f += l[t++] << i, i += 8;
              }
              f >>>= w, i -= w, e.back += w;
            }
            if (f >>>= d, i -= d, e.back += d, u & 64) {
              a.msg = "invalid distance code", e.mode = h;
              break;
            }
            e.offset = g, e.extra = u & 15, e.mode = ke;
          case ke:
            if (e.extra) {
              for (R = e.extra; i < R; ) {
                if (r === 0)
                  break e;
                r--, f += l[t++] << i, i += 8;
              }
              e.offset += f & (1 << e.extra) - 1, f >>>= e.extra, i -= e.extra, e.back += e.extra;
            }
            if (e.offset > e.dmax) {
              a.msg = "invalid distance too far back", e.mode = h;
              break;
            }
            e.mode = xe;
          case xe:
            if (k === 0)
              break e;
            if (o = c - k, e.offset > o) {
              if (o = e.offset - o, o > e.whave && e.sane) {
                a.msg = "invalid distance too far back", e.mode = h;
                break;
              }
              o > e.wnext ? (o -= e.wnext, Z = e.wsize - o) : Z = e.wnext - o, o > e.length && (o = e.length), P = e.window;
            } else
              P = s, Z = p - e.offset, o = e.length;
            o > k && (o = k), k -= o, e.length -= o;
            do
              s[p++] = P[Z++];
            while (--o);
            e.length === 0 && (e.mode = A);
            break;
          case ue:
            if (k === 0)
              break e;
            s[p++] = e.length, k--, e.mode = A;
            break;
          case X:
            if (e.wrap) {
              for (; i < 32; ) {
                if (r === 0)
                  break e;
                r--, f |= l[t++] << i, i += 8;
              }
              if (c -= k, a.total_out += c, e.total += c, c && (a.adler = e.check = /*UPDATE(state.check, put - _out, _out);*/
              e.flags ? T(e.check, s, c, p - c) : G(e.check, s, c, p - c)), c = k, (e.flags ? f : Ee(f)) !== e.check) {
                a.msg = "incorrect data check", e.mode = h;
                break;
              }
              f = 0, i = 0;
            }
            e.mode = we;
          case we:
            if (e.wrap && e.flags) {
              for (; i < 32; ) {
                if (r === 0)
                  break e;
                r--, f += l[t++] << i, i += 8;
              }
              if (f !== (e.total & 4294967295)) {
                a.msg = "incorrect length check", e.mode = h;
                break;
              }
              f = 0, i = 0;
            }
            e.mode = _e;
          case _e:
            S = Le;
            break e;
          case h:
            S = $;
            break e;
          case ge:
            return J;
          case Ze:
          default:
            return E;
        }
    return a.next_out = p, a.avail_out = k, a.next_in = t, a.avail_in = r, e.hold = f, e.bits = i, (e.wsize || c !== a.avail_out && e.mode < h && (e.mode < X || n !== j)) && Ie(a, a.output, a.next_out, c - a.avail_out), M -= a.avail_in, c -= a.avail_out, a.total_in += M, a.total_out += c, e.total += c, e.wrap && c && (a.adler = e.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
    e.flags ? T(e.check, s, c, a.next_out - c) : G(e.check, s, c, a.next_out - c)), a.data_type = e.bits + (e.last ? 64 : 0) + (e.mode === I ? 128 : 0) + (e.mode === L || e.mode === K ? 256 : 0), (M === 0 && c === 0 || n === j) && S === C && (S = Me), S;
  }
  function Pe(a) {
    if (!a || !a.state)
      return E;
    var n = a.state;
    return n.window && (n.window = null), a.state = null, C;
  }
  function Ue(a, n) {
    var e;
    return !a || !a.state || (e = a.state, !(e.wrap & 2)) ? E : (e.head = n, n.done = !1, C);
  }
  function We(a, n) {
    var e = n.length, l, s, t;
    return !a || !a.state || (l = a.state, l.wrap !== 0 && l.mode !== z) ? E : l.mode === z && (s = 1, s = G(s, n, e, 0), s !== l.check) ? $ : (t = Ie(a, n, e, e), t ? (l.mode = ge, J) : (l.havedict = 1, C));
  }
  return m.inflateReset = Se, m.inflateReset2 = me, m.inflateResetKeep = pe, m.inflateInit = Xe, m.inflateInit2 = Te, m.inflate = Be, m.inflateEnd = Pe, m.inflateGetHeader = Ue, m.inflateSetDictionary = We, m.inflateInfo = "pako inflate (from Nodeca project)", m;
}
export {
  na as __require
};
//# sourceMappingURL=inflate.es.js.map
